export function getPathFromRedirectParamWithDefault(
    redirectParam: string | undefined | null,
    defaultValue: string
): string {
    if (redirectParam) {
        return "/" + redirectParam;
    }
    return "/" + defaultValue;
}
